import { ApiError } from "@softmax/observatory-client/transport";
import type { Schemas } from "@softmax/observatory-client/types";
import { buildHref, type GameRouteScope } from "@softmax/web-addresses";
import { publicRead } from "@softmax/web-features/data/public-api";
import { deskFor } from "../desk-spec";
import { promptFromGuide } from "../entry/desk-guide";
import type { AgentGuideRead } from "../desk-records";

export { readPitchPage } from "./reads/pitch-page";

export async function getDeskGuide({
  data,
  signal,
}: {
  data: { coworldName: string; game: GameRouteScope };
  signal?: AbortSignal | undefined;
}): Promise<AgentGuideRead> {
  const spec = deskFor(data.coworldName);

  if (!spec) return { kind: "ready", guide: null };

  for (const page of spec.agentGuideSlugs) {
    const [result] = await Promise.allSettled([
      publicRead<Schemas["WikiPagePublic"]>({
        path: `/v2/wikis/${encodeURIComponent(data.coworldName)}/pages/${encodeURIComponent(page)}`,
        signal,
      }),
    ]);

    if (result.status === "rejected") {
      signal?.throwIfAborted();

      if (result.reason instanceof ApiError && result.reason.status === 404)
        continue;

      console.error("Agent guide read failed", result.reason);
      return { kind: "unavailable" };
    }

    const body = result.value.current_revision?.body;

    if (body?.trim()) {
      return {
        kind: "ready",
        guide: {
          prompt: promptFromGuide(body),
          href: buildHref({
            name: "game.wikiPage",
            game: data.game,
            page: page.split("/"),
          }),
        },
      };
    }
  }

  return { kind: "ready", guide: null };
}
